export default __webpack_public_path__ + "media/images/logo-w250-693d0f88f2269e32d9aff7c247313590.png";